import { Address } from './address.model';
import { Profile } from '../../profile/model/profile.model';
import { Company } from '../../company/model/company.model';

function isBlank(value: unknown): boolean {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim() === '')
  );
}

export function isAddressComplete(address?: Address): boolean {
  return (
    !!address &&
    !isBlank(address.street) &&
    !isBlank(address.postalCode) &&
    !isBlank(address.city) &&
    !isBlank(address.country)
  );
}

export function isProfileContactComplete(
  profile: Profile | undefined,
): boolean {
  if (!profile) {
    return true;
  }

  return !isBlank(profile.phoneNumber);
}

export function isProfileComplete(profile: Profile | undefined): boolean {
  if (!profile) {
    return true;
  }

  return (
    isProfileContactComplete(profile) &&
    isAddressComplete(profile.mailingAddress)
  );
}

export function isCompanyBusinessComplete(
  company: Company | undefined,
  isSingleDriver: boolean,
): boolean {
  if (!company) {
    return true;
  }

  const hasVatRate = company.vatRate !== null && company.vatRate !== undefined;

  const vatComplete =
    (hasVatRate && Number(company.vatRate) === 0) || !isBlank(company.vat);

  const coreComplete =
    !isBlank(company.phoneNumber) &&
    vatComplete &&
    !isBlank(company.taxId) &&
    !isBlank(company.iban) &&
    hasVatRate;

  const paymentComplete = !isSingleDriver || !isBlank(company.paymentTerms);

  return coreComplete && paymentComplete;
}

export function isCompanyComplete(
  company: Company | undefined,
  isSingleDriver: boolean,
): boolean {
  if (!company) {
    return true;
  }

  return (
    isCompanyBusinessComplete(company, isSingleDriver) &&
    isAddressComplete(company.billingAddress)
  );
}
